import styled from "styled-components";
import whiteLogo from "../../img/main/white_logo.png";

export default function Footer() {
	return (
		<FooterWrapper>
			<FooterContent>
				<FooterLeft>
					<img src={whiteLogo} alt="로고" />
					<div>
						신비로움이 깃든 동굴, 호리굴 <br />
						대표자 강재림 <span>|</span> 181-57-00813<br className="mobile-br" /><span className="hide-mobile">|</span> 2025-울산북구-0154 <span>|</span> 울산 북구 정자동 123-1 <br />
						<a href="tel:010-2544-5290">T. 010-2544-5290</a> <br />
						<p>COPYRIGHTⓒ HORIGUL 2025. ALL RIGHTS RESERVED.</p>
					</div>
				</FooterLeft>
				<FooterRight>
					<a href="https://www.instagram.com/stay_horigul/" target="_blank" rel="noopener noreferrer">
						{/* Instagram SVG */}
						<svg xmlns="http://www.w3.org/2000/svg" width="33" height="34" viewBox="0 0 33 34" fill="none">
							<path d="M18.0549 1.72266C19.7563 1.72719 20.6199 1.73627 21.3656 1.75744L21.659 1.76803C21.9978 1.78013 22.332 1.79525 22.7358 1.8134C24.345 1.88903 25.4431 2.14312 26.4065 2.5167C27.4047 2.90087 28.2456 3.42115 29.0865 4.26057C29.8558 5.0164 30.451 5.93104 30.8303 6.94065C31.2039 7.90409 31.458 9.00214 31.5336 10.6129C31.5517 11.0152 31.5669 11.3495 31.579 11.6898L31.588 11.9832C31.6107 12.7273 31.6198 13.591 31.6228 15.2925L31.6243 16.4208V18.4021C31.628 19.5053 31.6164 20.6085 31.5895 21.7114L31.5805 22.0048C31.5684 22.3451 31.5532 22.6793 31.5351 23.0817C31.4595 24.6924 31.2024 25.789 30.8303 26.7539C30.451 27.7635 29.8558 28.6782 29.0865 29.434C28.3307 30.2034 27.4161 30.7985 26.4065 31.1779C25.4431 31.5515 24.345 31.8055 22.7358 31.8812L21.659 31.9265L21.3656 31.9356C20.6199 31.9568 19.7563 31.9674 18.0549 31.9704L16.9266 31.9719H14.9468C13.8432 31.9758 12.7395 31.9642 11.6361 31.9371L11.3427 31.9281C10.9837 31.9145 10.6247 31.8988 10.2659 31.8812C8.65667 31.8055 7.55865 31.5515 6.59372 31.1779C5.58468 30.7983 4.67059 30.2032 3.91522 29.434C3.14531 28.6783 2.54967 27.7637 2.16988 26.7539C1.79631 25.7905 1.54223 24.6924 1.46661 23.0817L1.42123 22.0048L1.41367 21.7114C1.38579 20.6085 1.37319 19.5053 1.37586 18.4021V15.2925C1.37167 14.1893 1.38277 13.0861 1.40913 11.9832L1.41972 11.6898C1.43182 11.3495 1.44694 11.0152 1.46509 10.6129C1.54071 9.00214 1.7948 7.90561 2.16837 6.94065C2.54904 5.93063 3.14573 5.01595 3.91673 4.26057C4.67166 3.49156 5.58522 2.89644 6.59372 2.5167C7.55865 2.14312 8.65515 1.88903 10.2659 1.8134C10.6682 1.79525 11.004 1.78013 11.3427 1.76803L11.6361 1.75896C12.739 1.73208 13.8422 1.72049 14.9453 1.72417L18.0549 1.72266ZM16.5001 9.28497C14.4945 9.28497 12.571 10.0817 11.1529 11.4999C9.7347 12.9181 8.93798 14.8416 8.93798 16.8473C8.93798 18.8529 9.7347 20.7764 11.1529 22.1947C12.571 23.6129 14.4945 24.4096 16.5001 24.4096C18.5057 24.4096 20.4291 23.6129 21.8473 22.1947C23.2655 20.7764 24.0622 18.8529 24.0622 16.8473C24.0622 14.8416 23.2655 12.9181 21.8473 11.4999C20.4291 10.0817 18.5057 9.28497 16.5001 9.28497ZM16.5001 12.3099C17.0959 12.3098 17.686 12.4271 18.2365 12.655C18.787 12.8829 19.2873 13.2171 19.7087 13.6383C20.13 14.0596 20.4643 14.5597 20.6925 15.1102C20.9206 15.6607 21.038 16.2507 21.0381 16.8465C21.0382 17.4424 20.921 18.0324 20.693 18.583C20.4651 19.1335 20.131 19.6338 19.7097 20.0552C19.2885 20.4766 18.7883 20.8109 18.2379 21.039C17.6874 21.2671 17.0975 21.3846 16.5016 21.3847C15.2983 21.3847 14.1442 20.9066 13.2933 20.0557C12.4424 19.2048 11.9643 18.0507 11.9643 16.8473C11.9643 15.6439 12.4424 14.4898 13.2933 13.6389C14.1442 12.7879 15.2983 12.3099 16.5016 12.3099M24.4418 7.01628C23.9404 7.01628 23.4596 7.21546 23.105 7.57001C22.7505 7.92457 22.5513 8.40544 22.5513 8.90686C22.5513 9.40827 22.7505 9.88915 23.105 10.2437C23.4596 10.5983 23.9404 10.7974 24.4418 10.7974C24.9432 10.7974 25.4241 10.5983 25.7786 10.2437C26.1332 9.88915 26.3324 9.40827 26.3324 8.90686C26.3324 8.40544 26.1332 7.92457 25.7786 7.57001C25.4241 7.21546 24.9432 7.01628 24.4418 7.01628Z" fill="white"/>
						</svg>
					</a>
					<a href="http://pf.kakao.com/_DKqwn" target="_blank" rel="noopener noreferrer">
						{/* Kakao SVG */}
						<svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
							<path d="M25.25 0C28.0114 4.34873e-07 30.25 2.23858 30.25 5V25.25C30.25 28.0114 28.0114 30.25 25.25 30.25H5C2.23858 30.25 0 28.0114 0 25.25V5C4.34887e-07 2.23858 2.23858 0 5 0H25.25ZM15.501 5C10.254 5 6 9.11179 6 14.1836C6.00012 17.9281 7.50058 19.7163 9.55664 21.3467L9.56641 21.3516V25.7471C9.56641 25.954 9.79353 26.0736 9.95312 25.9502L13.5557 23.1533L13.6328 23.1895C14.2368 23.3055 14.8608 23.3662 15.499 23.3662C20.7459 23.3662 24.9998 19.2552 25 14.1836C25 9.11187 20.7478 5.00014 15.501 5ZM12.3174 10.4512C14.053 10.4513 15.3513 11.6106 15.6719 13.3721H14.2979C14.0884 12.4147 13.2649 11.8175 12.3174 11.8174C10.9751 11.8174 10.0812 12.8175 10.0811 14.1738C10.0796 15.5273 11.0957 16.5086 12.3154 16.5088C13.2473 16.5088 14.0447 15.9271 14.2842 15.0264H15.6621C15.3257 16.7579 14.0343 17.8935 12.3174 17.8936C10.3209 17.8936 8.73736 16.3379 8.7373 14.1729C8.7373 12.0077 10.3209 10.4512 12.3174 10.4512ZM18.084 13.2109C18.3875 12.73 18.8766 12.4942 19.542 12.4941C20.0807 12.4941 20.5213 12.6794 20.8633 13.0576C21.2151 13.4358 21.3916 13.9468 21.3916 14.6123V17.751H20.1289V14.7754C20.1287 14.0907 19.7472 13.7227 19.1602 13.7227C18.5047 13.7227 18.084 14.1415 18.084 14.9902V17.751H16.8213V10.4736H18.084V13.2109Z" fill="white"/>
						</svg>
					</a>
					<a href="https://www.youtube.com/@%ED%98%B8%EB%A6%AC%EA%B5%B4%EC%9D%B4%EC%9A%A9%EC%95%88%EB%82%B4" target="_blank" rel="noopener noreferrer">
						{/* Youtube SVG */}
						<svg xmlns="http://www.w3.org/2000/svg" width="33" height="34" viewBox="0 0 33 34" fill="none">
							<path fillRule="evenodd" clipRule="evenodd" d="M16.5 2.34766C17.8253 2.34766 19.1846 2.38891 20.5021 2.45641L22.0583 2.54641L23.5479 2.65328L24.9429 2.76766L26.2169 2.88766C27.5998 3.01495 28.9012 3.72847 29.8919 4.90253C30.8826 6.0766 31.4991 7.6359 31.6327 9.30578L31.6946 10.1027L31.8109 11.8089C31.9194 13.577 32 15.5045 32 17.3477C32 19.1908 31.9194 21.1183 31.8109 22.8864L31.6946 24.5927L31.6327 25.3895C31.499 27.0597 30.8824 28.6192 29.8913 29.7933C28.9003 30.9674 27.5986 31.6808 26.2154 31.8077L24.9444 31.9258L23.5494 32.042L22.0583 32.1489L20.5021 32.2389C19.1688 32.3088 17.8345 32.345 16.5 32.3477C15.1655 32.345 13.8312 32.3088 12.4979 32.2389L10.9417 32.1489L9.45215 32.042L8.05715 31.9258L6.78305 31.8077C5.40016 31.6804 4.09876 30.9668 3.10807 29.7928C2.11738 28.6187 1.50095 27.0594 1.36735 25.3895L1.30535 24.5927L1.1891 22.8864C1.07104 21.0435 1.00797 19.1961 1 17.3477C1 15.5045 1.0806 13.577 1.1891 11.8089L1.30535 10.1027L1.36735 9.30578C1.50089 7.63619 2.1171 6.07713 3.10748 4.9031C4.09785 3.72908 5.39889 3.01537 6.7815 2.88766L8.05405 2.76766L9.44905 2.65328L10.9402 2.54641L12.4963 2.45641C13.8301 2.38652 15.165 2.35026 16.5 2.34766ZM13.4 12.8008V21.8945C13.4 22.7608 14.175 23.3008 14.795 22.8695L21.305 18.3227C21.4467 18.224 21.5643 18.082 21.6461 17.9108C21.728 17.7396 21.771 17.5454 21.771 17.3477C21.771 17.1499 21.728 16.9557 21.6461 16.7845C21.5643 16.6134 21.4467 16.4713 21.305 16.3727L14.795 11.8277C14.6536 11.7289 14.4932 11.6769 14.3299 11.6769C14.1666 11.677 14.0061 11.729 13.8647 11.8278C13.7233 11.9267 13.606 12.0688 13.5244 12.2399C13.4428 12.411 13.3999 12.6051 13.4 12.8027V12.8008Z" fill="white"/>
						</svg>
					</a>
				</FooterRight>
			</FooterContent>
		</FooterWrapper>
	);
}

const FooterWrapper = styled.footer`
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: 'Pretendard', sans-serif;
	padding: 3.75rem 0;
	background: transparent;
`;

const FooterContent = styled.div`
	width: 70%;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	@media (max-width: 1024px) {
		width: 95%;
		flex-direction: column;
		gap: 2rem;
		justify-content: center;
		align-items: center;
	}
`;

const FooterLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 1.5rem;
	font-size: 0.875rem;
	color: #fff;
	img {
		height: 5.25rem;
	}
	div {
		line-height: 1.5;
		font-weight: 300;
		span {
			color: #ffffff70;
			margin: 0 0.5rem;
		}
		p {
			color: #ffffff70;
			margin-top: 0.5rem;
		}
	}
	@media (max-width: 1024px) {
		flex-direction: column;
		align-items: center;
		text-align: center;
	}
	@media (max-width: 768px) {
		img {
			height: 3.75rem;
		}
	}
`;

const FooterRight = styled.div`
	display: flex;
	align-items: center;
	gap: 0.25rem;
	a svg path {
		fill: #ffffff70;
		transition: fill 0.2s;
	}
	a:hover svg path {
		fill: #fff;
	}
	@media (max-width: 768px) {
		margin-bottom: 2rem;
	}
`;